import { render, staticRenderFns } from "./QuoteFormCRMActionsSidebar.vue?vue&type=template&id=bdd12f10&scoped=true"
import script from "./QuoteFormCRMActionsSidebar.vue?vue&type=script&lang=js"
export * from "./QuoteFormCRMActionsSidebar.vue?vue&type=script&lang=js"
import style0 from "./QuoteFormCRMActionsSidebar.vue?vue&type=style&index=0&id=bdd12f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd12f10",
  null
  
)

export default component.exports